import UI from "@mile-meeting/mile-ui";
import { ko } from "date-fns/locale";
import { useEffect, useRef, useState } from "react";
import { Calendar } from "react-date-range";

export default function CalendarInput({ value, onChange }: { value: Date; onChange?: (date: Date) => void }) {
  const year = value.getFullYear();
  const month = value.getMonth() + 1;
  const date = value.getDate();
  const today: Date = new Date();
  const after180Days: Date = new Date();
  after180Days.setDate(today.getDate() + 180);
  const ref = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    const handler = (event: any) => {
      if (open && ref.current && !ref.current.contains(event.target)) {
        setOpen?.(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [open]);

  return (
    <div className="calendar-selector" style={{ position: "relative", width: "100%" }} onFocus={() => setOpen(true)}>
      <UI.Input
        prefixIcon="calendar"
        showPrefixIcon
        value={`${year}. ${month.toString().padStart(2, "0")}. ${date.toString().padStart(2, "0")}`}
        width={"100%"}
      />
      <div
        ref={ref}
        className="calendar-modal"
        style={{
          display: open ? "block" : "none",
          position: "absolute",
          boxShadow: "var(--alias-style-shadow-strong)",
          backgroundColor: "white",
          zIndex: 1002,
          width: 356,
          left: 2,
        }}
      >
        <Calendar
          locale={ko}
          date={value}
          onChange={(date) => onChange?.(date)}
          minDate={today}
          maxDate={after180Days}
        />
      </div>
    </div>
  );
}
